var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "search" }, [
    _c("input", {
      staticClass: "search--input",
      attrs: { type: "text", placeholder: _vm.$t("actions.search") + "..." },
      domProps: { value: _vm.dataSource.search },
      on: {
        keyup: function($event) {
          return _vm.search($event.target.value)
        }
      }
    }),
    _c("span", { staticClass: "glicon-fb-search" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }